module.exports = __webpack_public_path__ + "static/media/twelveV.abbb2376.png";